import { helper } from '@ember/component/helper';

const THEME_MAP = {
  1: 'teal',
  2: 'blue',
  3: 'warm',
  4: 'monochrome',
};

export default helper(function themeClass([themeValue]) {
  return THEME_MAP[themeValue] || 'teal';
});
